// ListViewItemFieldRow.jsx

import React from 'react';

// CSS
import './ListViewItemFieldRow.css';

// Components
import ProfilePhoto from 'components/profilephoto/ProfilePhoto';

/**
 * ListViewItemFieldRow
 *
 * Renders one field row within a list item.
 *
 * @param {object|string} fieldValue - Field display value descriptor or plain text.
 * @param {number} index - Field index within the list item.
 * @param {string} nodeKey - Parent node key.
 * @param {object} theme - Active theme tokens.
 *
 * @returns {ReactNode} The rendered field row.
 */
const ListViewItemFieldRow = ({
  fieldValue,
  index,
  nodeKey,
  theme,
}) => {

  if (!fieldValue) return null;

  let content = null;

  if (fieldValue?.kind === 'people') {
    const profiles = Array.isArray(fieldValue?.profiles) ? fieldValue.profiles : [];
    if (!profiles.length) return null;

    content = (
      <span className="list-view-item-field-people">
        {profiles.map((person) => (
          <span
            className="list-view-item-person"
            key={`list_field_person_${nodeKey}_${index}_${person.key}`}
          >
            <ProfilePhoto
              allowNavigation={false}
              borderWidth={1}
              node={{
                coverUrl: person.coverUrl || null,
                key: person.key,
                name: person.name,
                title: person.name,
              }}
              size={14}
            />

            {/* PERSON NAME */}
            <span
              className="list-view-item-person-name"
            >
              {person.name}
            </span>
          </span>
        ))}
      </span>
    );
  } else {
    const textValue = typeof fieldValue === 'string' ? fieldValue : fieldValue?.value;
    if (!textValue) return null;

    content = (
      <span className="list-view-item-field-value-wrap">

        {/* FIELD VALUE */}
        <span className="list-view-item-field-value">{textValue}</span>
      </span>
    );
  }

  // ----- RENDER ----- //

  return (
    <div className="list-view-item-field">
      {content}
    </div>
  );
};

// Dev Tools
ListViewItemFieldRow.displayName = 'ListViewItemFieldRow';

export default ListViewItemFieldRow;
